module.exports = __webpack_public_path__ + "static/media/default_gray.e9fc6a84.png";